import { EventEmitter, Injectable } from '@angular/core';
import { Configuration } from '../configurations/shared.config';
import { AuthenticationService } from './authentication.service';
import * as signalR from '@microsoft/signalr';

@Injectable()
export class SignalRCoreNotificationService {

    private normaOrderHubName: string = '/normaOrderHub';
    private workOrderHubName: string = '/workOrderHub';
    private userHubName: string = '/userHub';

    private normaOrderConnection : signalR.HubConnection;
    private workOrderConnection : signalR.HubConnection;
    private userConnection : signalR.HubConnection;

    public connectionEstablished: EventEmitter<Boolean>;

    public normaOrderCreated: EventEmitter<any>;
    public normaOrderUpdated: EventEmitter<any>;
    public normaOrderChanged: EventEmitter<any>;
    public UpdateOrderStatus: EventEmitter<any>;

    public workOrderChanged: EventEmitter<any>;
    public workOrderCreatedAndEdited: EventEmitter<any>;
    public workOrderDetailsChanged: EventEmitter<any>;

    public userStatusChanged: EventEmitter<any>;

    public SlaAlertsCountsChanged: EventEmitter<any>;
    public SlaAlertOrderUpdated: EventEmitter<any>;
    public SlaAlertOrderRemoved: EventEmitter<any>;

    public statusCountertUpdated: EventEmitter<any>;

    public updateOrderStatusCounters: EventEmitter<any>;
    public connectionExists: Boolean;

    private currentUser: any;

    constructor(private auth: AuthenticationService) {
        this.connectionEstablished = new EventEmitter<any>();

        this.normaOrderCreated = new EventEmitter<any>();
        this.normaOrderUpdated = new EventEmitter<any>();
        this.normaOrderChanged = new EventEmitter<any>();
        this.UpdateOrderStatus = new EventEmitter<any>();

        this.workOrderCreatedAndEdited = new EventEmitter<any>();
        this.workOrderChanged = new EventEmitter<any>();
        this.workOrderDetailsChanged = new EventEmitter<any>();

        this.userStatusChanged = new EventEmitter<any>();

        this.SlaAlertsCountsChanged = new EventEmitter<any>();
        this.SlaAlertOrderUpdated= new EventEmitter<any>();
        this.SlaAlertOrderRemoved = new EventEmitter<any>();
        this.statusCountertUpdated = new EventEmitter<any>();
        this.updateOrderStatusCounters = new EventEmitter<any>();
        this.initalizeConnections();       
    }

    public initalizeConnections(){
        this.currentUser = this.auth.getCurrentUser();

        if(this.currentUser){
            this.normaOrderConnection = new signalR.HubConnectionBuilder().withUrl(Configuration.urls.signalrCoreEndpoint + this.normaOrderHubName + '?Username=' + this.currentUser.userName).withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (x) => 1,
            }).build();
    
            this.workOrderConnection = new signalR.HubConnectionBuilder().withUrl(Configuration.urls.signalrCoreEndpoint + this.workOrderHubName + '?Username=' + this.currentUser.userName).withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (x) => 1,
            }).build();
    
            this.userConnection = new signalR.HubConnectionBuilder().withUrl(Configuration.urls.signalrCoreEndpoint + this.userHubName).withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (x) => 1,
            }).build();
            
            this.startNormaOrderConnection();
            this.startWorkOrderConnection();
            this.startUserConnection();
            this.registerOnServerEvents();
        }        
    }

    public startNormaOrderConnection(): void {
        if (this.currentUser) {
            this.normaOrderConnection.start().then((data) => {
                this.connectionEstablished.emit(true);
                this.connectionExists = true;
            }).catch((error) => {
                this.connectionEstablished.emit(false);
                setTimeout(() => this.startNormaOrderConnection(), 1);
                return;
            });

        }
    }

    public startWorkOrderConnection(): void {
        if (this.currentUser) {
            this.workOrderConnection.start().then(() => {
                this.connectionEstablished.emit(true);
                this.connectionExists = true;
            }).catch((error) => {
                this.connectionEstablished.emit(false);
                setTimeout(() => this.startWorkOrderConnection(), 1);
                return;
            });
        }
    }

    public startUserConnection(): void {
        this.userConnection.start().then(() => {
            this.connectionEstablished.emit(true);
            this.connectionExists = true;
        }).catch((error) => {
            this.connectionEstablished.emit(false);
            setTimeout(() => this.startUserConnection(), 1);
            return;
        });
    }

    private registerOnServerEvents(): void {
        //// normaOrderConnection
        //this.normaOrderConnection.on('receiveNormaOrderStatus', (data: any) => {
        //    console.log('on receiveNormaOrderStatus');
        //    console.log(data);
        //    this.invokeReceiveChangeNormaOrderStatus(data);
        //    this.normaOrderChanged.emit(data);
        //});

        // When Update order Specific
        this.normaOrderConnection.on('receiveNormaOrderUpdated', (data: any) => {
            debugger
            console.log('on receiveNormaOrderUpdated');
            console.log(data);
            // this.invokeReceiveSendNormaOrderCreated(data);
            this.normaOrderUpdated.emit(data);
        });

        // When Create New Order
        this.normaOrderConnection.on('receiveNormaOrderCreated', (data: any) => {
            debugger
            console.log('on receiveNormaOrderCreated');
            console.log(data);
            // this.invokeReceiveSendNormaOrderCreated(data);
            this.normaOrderCreated.emit(data);
        });
        // Update Order Status When Edit Work Order
        this.normaOrderConnection.on('receiveUpdateOrderStatus', (data: any) => {
            debugger
            console.log('on receiveUpdateOrderStatus');
            console.log(data);
            this.UpdateOrderStatus.emit(data);
        });
        //this.normaOrderConnection.on('receiveSlaAlertsCountsChanged', (data: any) => {
        //    console.log('on receiveSlaAlertsCountsChanged');
        //    console.log(data);
        //    //this.invokeReceiveSendNormaOrderCreated(data);
        //    this.SlaAlertsCountsChanged.emit(data);
        //});

        //this.normaOrderConnection.on('receiveSlaAlertOrderUpdated', (data: any) => {
        //    console.log('on receiveSlaAlertOrderUpdated');
        //    console.log(data);
        //    //this.invokeReceiveSendNormaOrderCreated(data);
        //    this.SlaAlertOrderUpdated.emit(data);
        //});

        //this.normaOrderConnection.on('receiveSlaAlertOrderRemoved', (data: any) => {
        //    console.log('on receiveSlaAlertOrderRemoved');
        //    console.log(data);
        //    //this.invokeReceiveSendNormaOrderCreated(data);
        //    this.SlaAlertOrderRemoved.emit(data);
        //});

        //this.normaOrderConnection.on('receiveStatusCountertUpdated', (data: any) => {
        //    console.log('on receiveStatusCountertUpdated');
        //    console.log(data);
        //    //this.invokeReceiveSendNormaOrderCreated(data);
        //    this.statusCountertUpdated.emit(data);
        //});

        //this.normaOrderConnection.on('receiveOrderStatusCountersUpdated', (data: any) => {
        //    console.log('on receiveOrderStatusCountersUpdated');
        //    console.log(data);
        //    //this.invokeReceiveSendNormaOrderCreated(data);
        //    this.updateOrderStatusCounters.emit(data);
        //});

        
        // workOrderConnection
        this.workOrderConnection.on('receiveWorkOrderCreated', (data: any) => {
            console.log('on receiveWorkOrderCreated');
            console.log(data);
           // this.invokeReceiveSendWorkOrderCreated(data);
            this.workOrderCreatedAndEdited.emit(data);
        });

        //this.workOrderConnection.on('receiveWorkOrderStatus', (data: any) => {
        //    console.log('on receiveWorkOrderStatus');
        //    console.log(data);
        //    this.invokeReceiveChangeWorkOrderStatus(data);
        //    this.workOrderChanged.emit(data);
        //});
  
        //this.workOrderConnection.on('receiveWorkOrderDetailsChanges', (data: any) => {
        //    console.log('on receiveWorkOrderDetailsChanges');
        //    console.log(data);
        //    this.invokeReceiveSendWorkOrderDetailsChanges(data);
        //    this.workOrderDetailsChanged.emit(data);
        //});  
        //// userConnection 
        this.userConnection.on('receiveUserStatus', (userId: any, onlineStatus: any) => {
            console.log('on receiveUserStatus');
            console.log(userId);
            console.log(onlineStatus);
            let userData = {
                userId: userId,
                onlineStatus: onlineStatus
            }
            this.userStatusChanged.emit(userData);
        });  
    }

    private invokeReceiveChangeNormaOrderStatus(data: any): void {
        this.normaOrderConnection.invoke("ConfirmChangeNormaOrderStatus", data, this.currentUser.userName);
    }
    private invokeReceiveSendNormaOrderCreated(data: any): void {
        this.normaOrderConnection.invoke("ConfirmSendNormaOrderCreated", data, this.currentUser.userName);
    }

    private invokeReceiveChangeWorkOrderStatus(data: any): void {
        this.workOrderConnection.invoke("ConfirmChangeWorkOrderStatus", data, this.currentUser.userName);
    }
    private invokeReceiveSendWorkOrderDetailsChanges(data: any): void {
        this.workOrderConnection.invoke("ConfirmSendWorkOrderDetailsChanges", data, this.currentUser.userName);
    }
    private invokeReceiveSendWorkOrderCreated(data: any): void {
        this.workOrderConnection.invoke("ConfirmSendWorkOrderCreated", data, this.currentUser.userName);
    }

    public closeNormaOrderConnection(): void {
        this.normaOrderConnection.stop().then((data) => {
            this.connectionEstablished = new EventEmitter<any>();
            this.connectionExists = false;
        });
    }

    public closeWorkOrderConnection(): void {
        this.workOrderConnection.stop().then((data) => {
            this.connectionEstablished = new EventEmitter<any>();
            this.connectionExists = false;
        });
    }

    public closeUserConnection(): void {
        this.userConnection.stop().then((data) => {
            this.connectionEstablished = new EventEmitter<any>();
            this.connectionExists = false;
        });
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/signalRCore-notification.service.ts